<template>
  <div class="@container/actions">
    <div
      class="@md/actions:flex-row @md/actions:flex-row-reverse flex flex-col gap-3"
    >
      <course-program-download-cta
        block
        color="dark"
        :course="course"
        icon="ph:download-simple"
        origin="course_list"
      >
        Programme
      </course-program-download-cta>

      <app-button
        block
        color="dark"
        :to="coursePageUrl"
        variant="outlined"
        @click.stop
      >
        Voir le détail
      </app-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from "#vue-router";

const properties = defineProps<{
  course: Pick<DatabaseTable<"courses">, "slug" | "title" | "id">;
}>();

const coursePageUrl = computed<RouteLocationRaw>(() => {
  return { name: "courses-slug", params: { slug: properties.course.slug } };
});
</script>
